export default {
  development: {
    host: "unicapsule.local",
    apiPort: "http://unicapsule.local",
    apiPrefix: '/api/v1',
    port: 8020,
    i18n: true,
    supportedLang: ["en-US", "zh-CN", "zh-HK"],
    defalultLang: "zh-CN",
    fullHost: "http://unicapsule.local",
    embedServer: "http://embed.local/api/embed",
    providers: {
      google: {
        url: "http://localhost:8020/auth/google",
        clientId: "945510672914-k8ci5ktg4fn71oh03ru7kihqbirtoks5.apps.googleusercontent.com",
        scope: ["profile", "email"]
      }
    },
    map: {
      baidu: "vxPd39AGdvPZkIA6yft9sKUlDnYvDZlw",
      google: "AIzaSyDnxMDAqe2W7Bx4gvl0P3JwrnyPwphMxFs",
      weather: "4f561def674347d2a647ddcac22cb73e"
    },
    ws: "unicapsule.local/ws/",
    ossApi: "https://kaaxaa-upload-temp.oss-cn-beijing.aliyuncs.com",
    icp: "京ICP备16011764号-5",
    fileStorageApi:'https://uploader2.49miles.cn'
  },
  production: {
    host: "unicapsule.com",
    port: 80,
    apiPort: "https://api.unicapsule.com",
    apiPrefix: '/api/v1',
    sender: "noreply@unicapsule.com",
    i18n: true,
    supportedLang: ["en-US", "zh-CN", "zh-HK"],
    defalultLang: "en-US",
    fullHost: "https://unicapsule.com",
    embedServer: "https://embed.unicapsule.com/api/embed",
    providers: {
      google: {
        url: "https://unicapsule.com/auth/google",
        clientId: "945510672914-k8ci5ktg4fn71oh03ru7kihqbirtoks5.apps.googleusercontent.com",
        scope: ["profile", "email"]
      }
    },
    map: {
      google: "AIzaSyDnxMDAqe2W7Bx4gvl0P3JwrnyPwphMxFs",
      weather: "4f561def674347d2a647ddcac22cb73e"
    },
    ws: "unicapsule.com/ws/",
    ossApi: "https://unicapsule.oss-cn-beijing.aliyuncs.com",
    icp: "京ICP备16011764号-5",
    fileStorageApi:'https://us-uploader.49miles.cn'
  }
};
